import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from './../services/notification.service';

@Component({
  selector: 'ebw-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss']
})
export class NotificationMenuComponent implements OnInit, OnDestroy {
  notifications$ = this.notificationService.notifications$;
  unreadNotificationCount$ = this.notificationService.unreadNotificationCount$;

  constructor(private notificationService: NotificationService) {}

  interval: any;

  ngOnInit() {
    this.notificationService.getNotifications();
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
